import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M12.465 2.988c-2.39-.097-4.75.58-6.644 1.923-1.895 1.344-3.204 3.276-3.645 5.453-.408 2.017-.038 4.086 1.025 5.87l-1.15 3.45a1 1 0 0 0 1.157 1.294l4.374-.93c2.04.907 4.363 1.16 6.584.72 2.338-.463 4.433-1.67 5.88-3.425 1.45-1.759 2.146-3.947 1.93-6.155-.217-2.208-1.325-4.244-3.082-5.742-1.754-1.496-4.04-2.361-6.43-2.458"
      }
    )
  }
);
export {
  r as default
};
